import type { ReceiptTemplate } from '../schema';

export const discordTemplate: ReceiptTemplate = {
  id: 'discord',
  name: 'Discord Receipt',
  brand: 'DISCORD',
  description: 'Discord Nitro receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'dc-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'DISCORD',
        businessNameFontSize: 22,
        addressLines: ['PAYMENT RECEIPT'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'dc-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'invoice', label: 'Invoice:', value: 'DC-847291034' },
          { id: 'user', label: 'User:', value: 'JohnDoe#1234' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'type', label: 'Type:', value: 'Monthly' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'dc-plan',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'left', message: 'PLAN: Discord Nitro\nBILLING: Monthly\nNEXT BILLING: 02/04/2026', fontSize: 12, showDivider: true, dividerStyle: 'dashed', isBold: false },
    },
    {
      id: 'dc-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'nitro', label: 'DISCORD NITRO', value: '9.99', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '0.82', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '10.81', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'dc-payment',
      type: 'payment',
      enabled: true,
      config: { alignment: 'left', method: 'VISA ****4144', fields: [], showDivider: true, dividerStyle: 'dashed' },
    },
    {
      id: 'dc-footer',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: 'PAYMENT SUCCESSFUL\n\nENJOY NITRO', fontSize: 12, showDivider: false, dividerStyle: 'solid', isBold: false },
    },
  ],
  updatedAt: new Date().toISOString(),
};

